import styled from "styled-components";

export const WarningBadge = styled.div`
  display: flex;
  align-self: stretch;
  border-radius: 6px;
  background-color: var(--black-300);
  border-left: 8px solid var(--orange);
  padding: 0.9rem 0.8rem;
  color: var(--white-200);
  font-family: DM Sans, sans-serif;
  margin: 2rem 0rem;

  h3 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
`;
